"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      shadows = _ref.shadows;
  return {
    wrapper: {
      background: palette.background.paper,
      boxShadow: shadows[2],
      width: '100%',
      padding: '1rem'
    },
    title: {
      fontWeight: 'bold',
      display: 'block',
      marginBottom: '.3rem',
      color: palette.text.primary
    },
    size: {
      color: palette.text.secondary,
      fontSize: '.8rem'
    },
    icon: {
      color: palette.text.secondary
    }
  };
});
var _default = useStyles;
exports["default"] = _default;